import { API_v2 } from '@/services/config';
import { request } from '@@/exports';
/**
 * 获取消息列表
 * @param params
 * @param options
 */
export async function getSysMessagePeopleList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    messageType?: string;
    person_id?: string;
    query_all?: number | string;
    messageState?: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getSysMessagePeopleList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取待办日期
 * @param params
 * @param options
 */
export async function getTodoList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTodoList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取指定日期待办
 * @param params
 * @param options
 */
export async function getTodayTodo(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTodayTodo, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   添加待办
 * @param data
 * @param options
 */
export async function addTodoList(
  data: { title: string; content: string; remind_time: string },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addTodoList, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 文件库目录
 * @param params
 * @param options
 */
export async function getFileFoldersTree(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    date?: string;
    company_id?: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFileFoldersTree, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   消息已读
 * @param data
 * @param options
 */
export async function readSysMessage(
  data: { title: string; content: string; remind_time: string },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.readSysMessage, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取公司短信接收手机号列表
 * @param params
 * @param options
 */
export async function getCompanySmsPhoneList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    date?: string;
    company_id?: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanySmsPhoneList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   批量绑定手机号到公司
 * @param data
 * @param options
 */
export async function bindSmsPhones(
  data: { title: string; content: string; remind_time: string },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.bindSmsPhones, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   批量解绑手机号
 * @param data
 * @param options
 */
export async function unbindSmsPhones(
  data: { title: string; content: string; remind_time: string,company_id: number | string },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.unbindSmsPhones, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取命令列表
 * @param params
 * @param options
 */
export async function getCommandList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    date?: string;
    company_id?: number | string;
    sms_phone_id?: number | string;
    device_ids?: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCommandList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}